import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HomeUrl {
  private wordpressApiUrl = environment.baseUrl;
  private shareButtonUrl = environment.baseUrl2

  constructor() { /* empty */ }

  // Post listing
  getPosts(params?: { page?: number; per_page?: number; order?: 'asc' | 'desc'; categories?: number; tags?: number }) {
    let url = `${this.wordpressApiUrl}posts?_embed=1`;
    if (params) {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page.toString());
      if (params.per_page) queryParams.append('per_page', params.per_page.toString());
      if (params.order) queryParams.append('order', params.order);
      if (params.categories) queryParams.append('categories', params.categories.toString());
      if (params.tags) queryParams.append('tags', params.tags.toString());

      if (queryParams.toString()) {
        url += `&${queryParams.toString()}`;
      }
    }
    return url;
  }

  // Get specific post by ID
  getPostById(postId: number) {
    return `${this.wordpressApiUrl}posts/${postId}?_embed=1`;
  }

  // Get posts by category ID
  getPostsByCategory(categoryId: number, page = 1, perPage = 6) {
    return `${this.wordpressApiUrl}posts?categories=${categoryId}&per_page=${perPage}&page=${page}&_embed=1`;
  }

  // Get posts by tag ID
  getPostsByTag(tagId: number) {
    return `${this.wordpressApiUrl}posts?tags=${tagId}&_embed=1`;
  }

  // Get all categories
  getCategories() {
    return `${this.wordpressApiUrl}categories`;
  }

  // Get all tags
  getTags() {
    return `${this.wordpressApiUrl}tags`;
  }

  // Get comments for specific post
  getPostComments(postId: number) {
    return `${this.wordpressApiUrl}comments?post=${postId}`;
  }

  // Get all comments
  getAllComments() {
    return `${this.wordpressApiUrl}comments`;
  }

  // Get media by ID
  getMediaById(mediaId: number) {
    return `${this.wordpressApiUrl}media/${mediaId}`;
  }

  // Get AddToAny share buttons HTML from API
  getShareButtons() {
    return `${this.shareButtonUrl}share-buttons`;
  }

  // Get page by ID (for home page - page 103)
  getPageById(pageId: number) {
    return `${this.wordpressApiUrl}pages/${pageId}`;
  }

}
